import { getStorage } from './'

export const authHeader = () => {
  const user = getStorage('user')
  const token = user?.idToken || user?.token || null

  return token ? { Authorization: `Bearer ${token}` } : {}
}
